import React, {
    createContext,
    memo,
    PropsWithChildren,
    useContext,
    useMemo,
} from 'react';
import {
    BookerStateContext,
    RuntimeCalBookingActions,
    RuntimeCalBookingState,
} from './hooks/useRuntimeCalBookingState';
import { BookerContextType } from './types';

const BookerContext = createContext<BookerContextType | null>(null);

export const useBookingContext = () => {
    const context = useContext(BookerContext);
    if (!context) {
        throw new Error(
            'useBookingContext must be used within a BookerLoggerProvider'
        );
    }
    return context;
};

interface BookerContextProviderProps extends BookerContextType {
    state: RuntimeCalBookingState;
    actions: RuntimeCalBookingActions;
}

export const BookerContextProvider = memo(
    ({
        children,
        state,
        actions,
        ...props
    }: PropsWithChildren<BookerContextProviderProps>) => {
        const contextValue: BookerContextType = {
            ...props,
        };

        const stateValue: [RuntimeCalBookingState, RuntimeCalBookingActions] =
            useMemo(() => [state, actions], [state, actions]);

        return (
            <BookerContext.Provider value={contextValue}>
                <BookerStateContext.Provider value={stateValue}>
                    {children}
                </BookerStateContext.Provider>
            </BookerContext.Provider>
        );
    }
);
